import Request from './baseRequest'

// "Importar HTML" del diseñador v2 (Mailcraft): runs en admin-apis
// (/api/email-import-runs) que convierten un HTML en design JSON con un agente
// (parser + juez de visión + fixer). El admin crea el run y hace polling.

const getUserToken = () => JSON.parse(localStorage.getItem('auth.currentUser')).token;

const request = (method, path, payload, base = 'email-import-runs') => {
  const config = { headers: { authorization: `Bearer ${getUserToken()}` } }
  const url = `${window.config.VUE_APP_BACKEND}/api/${base}${path}`
  return method === 'get' ? Request.get(url, config) : Request.post(url, payload || {}, config)
}

export default {
  getEmailImportConfig: () => request('get', '/config'),
  createEmailImportRun: (payload) => request('post', '', payload),
  getEmailImportRun: (id) => request('get', `/${id}`),
  cancelEmailImportRun: (id) => request('post', `/${id}/cancel`),
  // "Armar con Calvin" (cuerpo del email): /api/email-compose-runs
  createEmailComposeRun: (payload) => request('post', '', payload, 'email-compose-runs'),
  getEmailComposeRun: (id) => request('get', `/${id}`, null, 'email-compose-runs'),
  cancelEmailComposeRun: (id) => request('post', `/${id}/cancel`, null, 'email-compose-runs'),
  // Manual de marca desde el sitio: /api/brand-kits/detect
  detectBrandKit: (payload) => request('post', '/detect', payload, 'brand-kits'),
}
